import React, { useEffect } from "react";
import { Card } from "@mui/material";
import Grid from "@mui/material/Grid";
import enGB from "date-fns/locale/en-GB";
import { useDispatch, useSelector } from "react-redux";
import {
  scheduledataSelector,
  scheduledata_updateMenuForDay
} from "reducers/scheduledata/scheduledata";
import { menudataSelector } from "reducers/menudata/menudata";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

import {
  appdataSelector
} from "reducers/appdata/appdata";

function ScheduleDay(props) {
  const dispatch = useDispatch();
  const scheduleData = useSelector(scheduledataSelector);
  const appdata = useSelector(appdataSelector);
  const menudata = useSelector(menudataSelector);
  const weekdays = [...Array(7).keys()].map(i => enGB.localize.day(i));

  const formatMenuLabel = option => {
    if (!option) return "";
    const menuName = option["MENU_" + appdata.language] || "";
    const allergens = option["MENU_ALGEN"] || "";
    return allergens ? `${menuName} (${allergens})` : menuName;
  };
  
  // check if there is menudata loaded, if not abort
  // check if there is menudata loaded, if not abort
  // check if there is menudata loaded, if not abort
  if (!menudata || !menudata.data || !menudata.data.lunchMenuItems) {
    return <div> no menudata </div>;
  }

  console.log("weekday", props.menus);

  let menu_1 = "";
  let menu_2 = "";
  let menu_3 = "";
  if (props.menus) {
    console.log("weekday - mappedmenus", props.mappedMenus);
    menu_1 = props.mappedMenus[parseInt(props.menus["MENU1_NUMB"])];
    menu_2 = props.mappedMenus[parseInt(props.menus["MENU2_NUMB"])];
    menu_3 = props.mappedMenus[parseInt(props.menus["MENU3_NUMB"])];
  }

  console.log("menu1", menu_1);
  console.log("menu2", menu_2);
  console.log("menu3", menu_3);
  let readableDate =
    props.sapDate.substring(6, 8) +
    "/" +
    props.sapDate.substring(4, 6) +
    "/" +
    props.sapDate.substring(0, 4);

  console.log("weekday - menu_1", menu_1);

  function handleMenuChange(event, key, value) {
    console.log("handleMenuChange", key, value);
    // selectedweeknumber
    // sapdate
    // key
    // value
    dispatch(
      scheduledata_updateMenuForDay({
        weeknumber: scheduleData.selectedWeekNumber,
        date: props.sapDate,
        values: { [key]: value }
      })
    );
  }

  let soups = [];
  let nonSoups = [];
  Object.values(menudata.data.lunchMenuItems).map(value => {
    if (value.DEACTIVATE == "X") {
      // item is disabled, ignore
    } else {
      if (value.SOUP_FLAG == "X") {
        soups.push(value);
      } else {
        nonSoups.push(value);
      }
    }
  });

  //soups = menudata.data.lunchMenuItems;
  //nonSoups = menudata.data.lunchMenuItems;

  return (
    <Card className="pb-2">
      <div className="container-fluid no-breadcrumb chapter FormIntegration pt-2 pb-2">
        <Grid container justify="space-between">
          <Grid item xs={12}>
            <div className="mt-2 mb-4">
              <b>{weekdays[props.id]}</b> ({readableDate})
            </div>
          </Grid>
          <Grid
            item
            xs={12}
            xl={4}
            key={
              "grid" + props.id + "_ " + props.sapDate + "_c" + Math.random()
            }
          >
            <Autocomplete
              className="mb-4 mb-xl-2"
              key={
                "three" + props.id + "_ " + props.sapDate + "_d" + Math.random()
              }
              disablePortal
              id="combo-box-demo"
              value={menu_3 ? menu_3 : null}
              options={soups}
              getOptionLabel={option => formatMenuLabel(option)}
              sx={{ width: 300 }}
              renderInput={params => (
                <TextField {...params} label="Menu 3 (soup)" />
              )}
              renderOption={(props, option, index) => {
                const key = props.id;
                return (
                  <li {...props} key={key}>
                    {formatMenuLabel(option)}
                  </li>
                );
              }}
              onChange={(event, value) => {
                console.log("on change", event, value);
                handleMenuChange(
                  event,
                  "MENU3_NUMB",
                  value ? value["MENU_NUMB"] : "000"
                );
              }}
            />
          </Grid>
          <Grid
            item
            xs={12}
            xl={4}
            key={
              "grid" + props.id + "_ " + props.sapDate + "_e" + Math.random()
            }
          >
            {/* this could be a loop:
            this could be a loop:
            this could be a loop: */}
            <Autocomplete
              className="mb-4 mb-xl-2"
              key={
                "one" + props.id + "_ " + props.sapDate + "_f" + Math.random()
              }
              disablePortal
              id="combo-box-demo"
              options={nonSoups}
              value={menu_1 ? menu_1 : null}
              getOptionLabel={option => formatMenuLabel(option)}
              sx={{ width: 300 }}
              renderInput={params => <TextField {...params} label="Menu 1" />}
              renderOption={(props, option, index) => {
                const key = props.id;
                return (
                  <li {...props} key={key}>
                    {formatMenuLabel(option)}
                  </li>
                );
              }}
              onChange={(event, value) => {
                console.log("on change", event, value);
                handleMenuChange(
                  event,
                  "MENU1_NUMB",
                  value ? value["MENU_NUMB"] : "000"
                );
              }}
            />
          </Grid>
          <Grid
            item
            xs={12}
            xl={4}
            key={
              "grid" + props.id + "_ " + props.sapDate + "_a" + Math.random()
            }
          >
            <Autocomplete
              className="mb-4 mb-xl-2"
              key={
                "two" + props.id + "_ " + props.sapDate + "_b" + Math.random()
              }
              disablePortal
              id="combo-box-demo"
              value={menu_2 ? menu_2 : null}
              options={nonSoups}
              getOptionLabel={option => formatMenuLabel(option)}
              sx={{ width: 300 }}
              renderInput={params => <TextField {...params} label="Menu 2" />}
              renderOption={(props, option, index) => {
                const key = props.id;
                return (
                  <li {...props} key={key}>
                    {formatMenuLabel(option)}
                  </li>
                );
              }}
              onChange={(event, value) => {
                console.log("on change", event, value);
                handleMenuChange(
                  event,
                  "MENU2_NUMB",
                  value ? value["MENU_NUMB"] : "000"
                );
              }}
            />
          </Grid>
        </Grid>
      </div>
    </Card>
  );
}

export default ScheduleDay;
